module.exports = __webpack_public_path__ + "media/zinc-medium.82c4b461.mp4";